import { useState } from "react";
import { toast } from "sonner";
import { Play } from "@phosphor-icons/react";
import api, { formatApiError } from "../../lib/api";
import { fmt$ } from "./utils";

export default function Payroll({ payrolls, onChange }) {
  const [period, setPeriod] = useState(new Date().toISOString().slice(0, 7));

  const run = async () => {
    try {
      await api.post("/hr/payroll/run", { period });
      toast.success(`Payroll run for ${period}`);
      onChange();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div>
      <div className="border-b border-zinc-950 p-5 flex flex-wrap items-end gap-4" data-testid="payroll-form">
        <div>
          <label className="label-sm text-zinc-500">Pay period</label>
          <input type="month" value={period} onChange={(e) => setPeriod(e.target.value)} data-testid="payroll-period-input" className="block border-b border-zinc-300 focus:border-zinc-950 bg-transparent py-2 text-sm tnum outline-none" />
        </div>
        <button onClick={run} className="bg-zinc-950 text-white text-xs font-semibold px-5 py-2.5 hover:bg-[#FF3E00] flex items-center gap-2" data-testid="payroll-run-btn">
          <Play size={12} weight="fill" /> RUN PAYROLL
        </button>
      </div>
      <table className="w-full text-sm">
        <thead className="bg-zinc-50 border-b border-zinc-950">
          <tr className="text-xs tracking-wider uppercase">
            <th className="text-left px-4 py-2.5">Period</th>
            <th className="text-right px-4 py-2.5">Employees</th>
            <th className="text-right px-4 py-2.5">Total</th>
            <th className="text-left px-4 py-2.5">Run at</th>
            <th className="text-left px-4 py-2.5">By</th>
          </tr>
        </thead>
        <tbody data-testid="payroll-tbody">
          {payrolls.map((p) => (
            <tr key={p.id} className="border-b border-zinc-100">
              <td className="px-4 py-2.5 font-semibold tnum">{p.period}</td>
              <td className="px-4 py-2.5 text-right tnum">{p.employee_count}</td>
              <td className="px-4 py-2.5 text-right tnum font-semibold">{fmt$(p.total_amount)}</td>
              <td className="px-4 py-2.5 text-xs text-zinc-500">{new Date(p.run_at).toLocaleString()}</td>
              <td className="px-4 py-2.5 text-xs text-zinc-500">{p.run_by}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
